import React, { useEffect } from "react";
import { connect } from "react-redux";
import { CardResetPinForm } from "../forms/card-reset-pin-form.component";
import { TravelExemptionMfaForm } from "../forms/auth-travel-exemption-mfa-form.component";
import { callPinUpdate, callPinValidation } from "../../../actions/cardControls.actions";
import CardControlsComplete from "../misc/card-controls-complete.component";

const ResetPinFlowComponent = (props) => {
  const { setProcessStep, processStep, backToCards, cardInfo } = props;
  const currentForm = props.form["ResetPin"];

  const mfaIsRequired = props.mfa.required === true;
  useEffect(() => {
    if (!mfaIsRequired) {
      setProcessStep(2);
    }
  }, []);

  switch (processStep) {
    case 1:
      if (!mfaIsRequired) {
        return null;
      }
      return <TravelExemptionMfaForm backToLoans={backToCards} advanceToNextStep={() => props.setProcessStep(2)} buttonText ="Back to Cards" />;
    case 2:
      return (
        <CardResetPinForm
          thisForm={currentForm}
          cardInfo={cardInfo}
          backToCards={backToCards}
          setProcessStep={setProcessStep}
          processStep={processStep}
          callPinUpdate={props.callPinUpdate}
          callPinValidation={props.callPinValidation}
          cardControlsInfo= {props.cardControls}
        />
      );
    case 3:
      return <CardControlsComplete {...props} />;
    default:
      return <div>Something has gone wrong.</div>;
  }
};

const mapDispatchToProps = {
  callPinUpdate,
  callPinValidation
};
const ResetPinFlow = connect(null, mapDispatchToProps)(ResetPinFlowComponent);

export default ResetPinFlow;



// WEBPACK FOOTER //
// ./src/components/card-controls/flow-components/reset-pin-flow.component.js